module.exports = __webpack_public_path__ + "static/media/becas.6d627c39.png";